import type { Dispatch, SetStateAction } from 'react';
import type { FormikErrors } from 'formik';

import type { AuthorizationData } from '../types';

import { isValidPhoneNumber } from 'app/design-system/components/PhoneInput/phone-input-helpers';
import type { tFunction } from 'app/lang';

import type { InitialValues } from '../components/AuthorizationModal/AuthorizationBody';

import dictionary from './Validate.dictionary.json';

const SHAKE_ANIM_DURATION = 600;

export function authorizationValidate(
  t: tFunction,
  values: InitialValues,
  data: AuthorizationData,
  setData: Dispatch<SetStateAction<AuthorizationData>>,
): FormikErrors<InitialValues> {
  const errors: FormikErrors<InitialValues> = {};

  if (!isValidPhoneNumber(values.phoneNumber)) {
    const newData = { ...data };
    const settingValue = (prevState: AuthorizationData) => ({ ...prevState, ...newData });

    errors.phoneNumber = t(dictionary.invalidPhoneNumber);

    newData.errorMessage = true;
    newData.shake = true;

    setData(settingValue);

    setTimeout(() => {
      newData.shake = false;
      setData(settingValue);
    }, SHAKE_ANIM_DURATION);
  }

  return errors;
}
